var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineStatusActiveAccountStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Online-Status-Active-Account--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Online Status Active Account Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online-status-active-account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M22.161013542857145 22.354194600000003c-0.005385300000000001 0.005358771428571429 -0.01074407142857143 0.010717542857142858 -0.016129371428571432 0.016076314285714287C20.02368612857143 24.49149548571429 19.233214285714286 27.307980857142855 19.233214285714286 30.07013571428572l-13.314477771428571 0c-4.054244845714286 0 -6.332767928571429 -4.334688985714286 -2.958439757142857 -6.582109971428571C5.987021057142857 21.47217265714286 9.621912857142858 20.297328342857142 13.531216200000001 20.297328342857142c3.1055406857142858 0 6.0379293857142855 0.7414205142857143 8.629797342857144 2.0568662571428575Z",
    clipRule: "evenodd",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.0481665 21.83388972857143c-2.3069511 -0.9889586142857144 -4.847990314285715 -1.536561385714286 -7.5169503 -1.536561385714286 -3.909303342857143 0 -7.544195142857143 1.1748443142857143 -10.570919442857143 3.1906974C-0.41403141428571427 25.73544672857143 1.8644916685714288 30.07013571428572 5.9187365142857145 30.07013571428572h12.104350457142857",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "M13.535832171428572 15.123434528571428c4.4150175 0 6.898489714285715 -2.4834722142857144 6.898489714285715 -6.898516242857143C20.434321885714287 3.809900785714286 17.95084967142857 1.3264285714285715 13.535832171428572 1.3264285714285715c-4.415044028571429 0 -6.898516242857143 2.4834722142857144 -6.898516242857143 6.898489714285715 0 4.415044028571429 2.4834722142857144 6.898516242857143 6.898516242857143 6.898516242857143Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.535832171428572 15.123434528571428c4.4150175 0 6.898489714285715 -2.4834722142857144 6.898489714285715 -6.898516242857143S17.95084967142857 1.3264285714285715 13.535832171428572 1.3264285714285715c-4.415044028571429 0 -6.898516242857143 2.483445685714286 -6.898516242857143 6.898489714285715s2.4834722142857144 6.898516242857143 6.898516242857143 6.898516242857143Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#ffffff",
    d: "M29.84464285714286 35.81357142857143c3.820114285714286 0 5.968928571428572 -2.148814285714286 5.968928571428572 -5.968928571428572S33.66475714285714 23.875714285714288 29.84464285714286 23.875714285714288 23.875714285714288 26.024528571428576 23.875714285714288 29.84464285714286s2.148814285714286 5.968928571428572 5.968928571428572 5.968928571428572Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.84464285714286 35.81357142857143c3.820114285714286 0 5.968928571428572 -2.148814285714286 5.968928571428572 -5.968928571428572S33.66475714285714 23.875714285714288 29.84464285714286 23.875714285714288 23.875714285714288 26.024528571428576 23.875714285714288 29.84464285714286s2.148814285714286 5.968928571428572 5.968928571428572 5.968928571428572Z",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineStatusActiveAccountStreamlineFlex);
export default __webpack_public_path__ + "static/media/Online-Status-Active-Account--Streamline-Flex.35486d1637201d34bc80987179a4fd0a.svg";
export { ForwardRef as ReactComponent };